import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IconMapper } from '../../helpers/icon-mapper';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cfa-app-brand-button',
    templateUrl: './app-brand-button.html',
    styleUrls: ['../../../styles/styles.scss', './app-brand-button.scss'],
    encapsulation: ViewEncapsulation.None
})
// tslint:disable-next-line:component-class-suffix
export class CfaAppBrandButton extends IconMapper {

    @Input() appName: string;

    icon = 'CFA';

    constructor() {
        super();
    }

}
